import { IPortalCourse } from './types';

export const convertCourse = ({ ...data }: IPortalCourse<string>): IPortalCourse<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
